//------------------------------------------------------------------------
// Main nav toggle
//------------------------------------------------------------------------
'use strict';
import Modal from '../lib/modals';
import Cookie from '../lib/cookie';

export default class Popup {
  constructor(el) {
    var id = el.getAttribute('data-popup-id');
    var disabled = el.getAttribute('data-popup-disabled');
    this.el = el;
    this.cta = this.el.querySelector('a');
    this.cookieData = {
      name: id,
      settings: {
        expires: parseFloat(1),
      },
    };

    // Check sessionStorage to see if modal should be shown
    // if ('sessionStorage' in window && !window.sessionStorage.popup) {
    //   this.init();
    // }

    if (!Cookie.get(id) && !disabled) {
      // SHOW the content
      this.init();
    }
  }

  init() {
    this.modal = new Modal(this.el);

    // Open on page load
    this.modal.open();

    // Update sessionStorage on close to prevent reopening
    this.modal.on('close', () => {
      Cookie.set(this.cookieData.name, true, {
        expires: this.cookieData.settings.expires,
      });
    });

    // We are binding this handler to ensure that we have access to the Modal object inside of the callback
    this.cta.addEventListener('click', this.handleClickingCta.bind(this));
  }

  // We noticed when clicking the CTA inside of the modal window the user would still see the modal
  // when visting the new page, so we are manually closing the window.
  // https://github.com/Threespot/pha-cms/issues/477
  handleClickingCta(event) {
    this.modal.close();
    Cookie.set(this.cookieData.name, true, {
      expires: this.cookieData.settings.expires,
    });
  }
}

// Init
let el = document.querySelector('#popup');
// Add page titles to the array below to prevent the popup from initializing
// https://github.com/Threespot/pha-cms/issues/484
let ignorePageTitles = ['Privacy Policy'];
// FYI Array.prototype.some() is supported in IE9+
let isIgnoredPage = ignorePageTitles.some(
  (title) => document.title.indexOf(title) === 0
);

if (el && !isIgnoredPage) {
  new Popup(el);
}